import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab-links"
export default class extends Controller {
  static targets = ['tab']
  static values = {
    changeUrl: { type: Boolean, default: true },
    changeParam: { type: String, default: 'view_part' },
    changeInputId: { type: String, default: null },
  }

  connect() {
    this.addEventListeners()
    this.tabTargets.find(el => el.classList.contains("active"))?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
  }

  disconnect() {
    this.removeEventListeners()
  }

  // Wenn ein Tab geklickt wird, wird der Name des Tabs in der URL gespeichert
  // So kann, wenn die Seite neu geladen wird, der Tab wieder geöffnet werden
  interceptTabClick(tab) {
    if (this.changeUrlValue) {
      let url = new URL(window.location)
      url.searchParams.set(this.changeParamValue, tab.dataset.bsTarget.replace('#', ''))
      window.history.replaceState(history.state, "", url)

      // hidden input anpasses, falls vorhanden
      if (this.hasChangeInputIdValue) {
        let input = document.getElementById(this.changeInputIdValue);
        if (input) {
          input.value = tab.dataset.bsTarget.replace('#', '')
        }
      }
    }
    tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
  }

  addEventListeners() {
    this.boundInterceptTabClick = [] // alle eventlistener sammeln
    this.tabTargets.forEach(tab => {
      let listener = this.interceptTabClick.bind(this, tab);
      this.boundInterceptTabClick.push(listener)
      tab.addEventListener('click', listener)
    })
  }

  removeEventListeners() {
    this.boundInterceptTabClick.forEach((listener, index) => {
      this.tabTargets[index].removeEventListener('click', listener)
    })
  }
}
